<template>
<div class="card-group justify-content-center p-3 flex-wrap">
    <div class="card-container">
        <CardContainer 
            title="Szerelés/Javítás" 
            buttonText="Ugrás a Javításhoz"
            href="/#javitas">
            <CdnImage 
                src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/broken-shutter"
                fallbackSrc="./static/assets/ruined-shutter.jpg"
                classes="card-img card-img-top"
                alt="Redőnyjavítás, Gurtnicsere, redőny motor csere, szúnyogháló csere" />
        </CardContainer>
    </div>
    <div class="card-container">
        <CardContainer 
            title="Termékek" 
            buttonText="Ugrás a Termékekhez"
            href="/termekek">
            <CdnImage 
                src="https://res.cloudinary.com/arnyekguru/image/upload/f_auto,q_auto/rolling-shutter-technical"
                fallbackSrc="./static/assets/rolling-shutter.jpg"
                classes="card-img card-img-top" 
                alt="Műanyag Redőny, Motoros Redőny, Szúnyogháló, Napellenző, Alumínium redőny" />
        </CardContainer>
    </div>
</div>
</template>

<script>
import CardContainer from '@/components/CardContainer.vue';
import CdnImage from './CdnImage.vue';

export default {
    name: 'ServiceSelector',
    components: {
        CardContainer,
        CdnImage,
    }
}
</script>

<style lang="scss" scoped>
.card-img {
    height: 400px;
    object-fit: cover;
}

.card-container {
    margin-left: 5%;
    margin-right: 5%;
    width: 35%;
    margin-top: 30px;
    margin-bottom: 30px;
}

@media screen and (max-width: 800px) {
    .card-container {
        margin-left: 0;
        margin-right: 0;
        width: 100%;
    }

    .card-img {
        height: 300px;
    }
}

</style>